module.exports = "<block>\n    <v-select slot=\"left\" :options=\"cityOptions\" v-model=\"selectedCity\" placeholder=\"Please choose...\" style=\"width:150px;\"></v-select>\n    <v-number-input slot=\"left\" kind=\"step\" :value=\"10\" style=\"margin-left:10px;\"></v-number-input>\n    <v-input slot=\"right\" type=\"search\" placeholder=\"Search name...\" style=\"width:240px;\"></v-input>\n    <v-button slot=\"right\" status=\"primary\" style=\"margin-left:10px;\">Search</v-button>\n</block>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/example/1-left-right.html
// module id = 207
// module chunks = 1